import { render, staticRenderFns } from "./OnHoldSummary.vue?vue&type=template&id=bffc07b0&"
import script from "./OnHoldSummary.vue?vue&type=script&lang=js&"
export * from "./OnHoldSummary.vue?vue&type=script&lang=js&"
import style0 from "./OnHoldSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports